@if (showBackButton) {
  <div class="inner-navigation">
    <div class="back" (click)="navigateBack()">
      <p class="text-button-small">{{ 'invoice-details.back-button' | translate }}</p>
    </div>
  </div>
}

<div class="invoice-title">
  <div class="status" [ngClass]="checkInvoiceStatus(invoice)">
    <p class="tag-12">{{ formatInvoiceStatus(invoice) | translate }}</p>
  </div>

  <div class="title">
    <h4>{{ 'invoice-details.invoice-title' | translate }} {{ invoice.invoiceNumber }}</h4>
  </div>
</div>

<!--<div class="top-actions" *ngIf="invoice.invoiceStatus === InvoiceStatus.OUTSTANDING">-->
<div class="top-actions">
  <button class="button icon-only" (click)="generateQRCode()">
    <mat-icon svgIcon="qr"></mat-icon>
  </button>
  @if (invoice.bexio_pdf_available) {
    <button class="button icon-only pdf-action"
      [disabled]="downloadingPdf"
      (click)="openInvoicePdf()">
      @if (downloadingPdf) {
        <mat-spinner diameter="18"></mat-spinner>
      } @else {
        <mat-icon svgIcon="file_dock"></mat-icon>
      }
    </button>
  }
</div>

<div class="details-part info">
  <div class="row with-actions">
    <div class="vertical">
      <div class="title">
        <p class="body-12">{{ 'invoice-details.iban' | translate }}</p>
      </div>

      <div class="value">
        <p class="subtitle-14">{{ recipientIbanFormated }}</p>
      </div>
    </div>

    <div class="actions">
      <button class="button icon-only" [cdkCopyToClipboard]="recipientIbanFormated">
        <mat-icon svgIcon="copy"></mat-icon>
      </button>
    </div>
  </div>

  <!-- Row for Firmenname -->
  <div class="row with-actions">
    <div class="vertical">
      <div class="title">
        <p class="body-12">{{ 'invoice-details.company-name' | translate }}</p>
      </div>
      <div class="value">
        <p class="subtitle-14">{{ recipientName }}</p>
      </div>
    </div>
    <div class="actions">
      <button class="button icon-only" [cdkCopyToClipboard]="recipientName">
        <mat-icon svgIcon="copy"></mat-icon>
      </button>
    </div>
  </div>

  <!-- Row for Adresse -->
  <div class="row with-actions">
    <div class="vertical">
      <div class="title">
        <p class="body-12">{{ 'invoice-details.address' | translate }}</p>
      </div>
      <div class="value">
        <p class="subtitle-14">{{ recipientStreet }} {{ recipientHouseNumber }}</p>
      </div>
    </div>
    <div class="actions">
      <button class="button icon-only" [cdkCopyToClipboard]="recipientStreet + ' ' + recipientHouseNumber">
        <mat-icon svgIcon="copy"></mat-icon>
      </button>
    </div>
  </div>

  <!-- Row for PLZ -->
  <div class="row with-actions">
    <div class="vertical">
      <div class="title">
        <p class="body-12">{{ 'invoice-details.zip' | translate }}</p>
      </div>
      <div class="value">
        <p class="subtitle-14">{{ recipientZIP }}</p>
      </div>
    </div>
    <div class="actions">
      <button class="button icon-only" [cdkCopyToClipboard]="recipientZIP">
        <mat-icon svgIcon="copy"></mat-icon>
      </button>
    </div>
  </div>

  <!-- Row for Ort -->
  <div class="row with-actions">
    <div class="vertical">
      <div class="title">
        <p class="body-12">{{ 'invoice-details.city' | translate }}</p>
      </div>
      <div class="value">
        <p class="subtitle-14">{{ recipientCity }}</p>
      </div>
    </div>
    <div class="actions">
      <button class="button icon-only" [cdkCopyToClipboard]="recipientCity">
        <mat-icon svgIcon="copy"></mat-icon>
      </button>
    </div>
  </div>
</div>

<div class="details-part info">
  @if (invoice.referenceNumber) {
    <div class="row with-actions">
      <div class="vertical">
        <div class="title">
          <p class="body-12">{{ 'invoice-details.reference-number-title' | translate }}</p>
        </div>
        <div class="value">
          <p class="subtitle-14">{{ invoice.referenceNumber }}</p>
        </div>
      </div>
      <div class="actions">
        <button class="button icon-only" [cdkCopyToClipboard]="invoice.referenceNumber">
          <mat-icon svgIcon="copy"></mat-icon>
        </button>
      </div>
    </div>
  }

  <div class="row with-actions">
    <div class="vertical">
      <div class="title">
        <p class="body-12">{{ 'invoice-details.due-date-title' | translate }}</p>
      </div>

      <div class="value">
        <p class="subtitle-14">{{ parseDueDate(invoice.dueDate) | date:'dd.MM.yyyy' }}</p>
      </div>
    </div>

    <div class="actions">
      <button class="button icon-only" [cdkCopyToClipboard]="(parseDueDate(invoice.dueDate) | date:'dd.MM.yyyy') || ''">
        <mat-icon svgIcon="copy"></mat-icon>
      </button>
    </div>
  </div>

  <div class="row with-actions">
    <div class="vertical">
      <div class="title">
        <p class="body-12">{{ 'invoice-details.total-amount' | translate }}</p>
      </div>

      <div class="value">
        <p class="subtitle-14">CHF {{ invoice.totalAmount | number:'1.2-2' }}</p>
      </div>
    </div>

    <div class="actions">
      <button class="button icon-only" [cdkCopyToClipboard]="invoice.totalAmount.toFixed(2)">
        <mat-icon svgIcon="copy"></mat-icon>
      </button>
    </div>
  </div>
</div>
